/* House of Quintana — theme behaviours */
(function () {
  'use strict';

  /* ---------- Transparent header (home / collection with image) ---------- */
  function initTransparentHeader() {
    var wrapper = document.querySelector('.header-wrapper--transparent');
    if (!wrapper) return;
    var section = wrapper.closest('.shopify-section');
    if (!section) return;
    section.classList.add('section-header');
    document.body.classList.add('hoq-transparent');

    var announcement = document.querySelector('.announcement-bar-section, .section-announcement-bar');
    var lastY = window.scrollY;
    var ticking = false;

    function update() {
      var y = window.scrollY;
      var annH = 0;
      if (announcement) {
        var el = announcement.closest ? announcement.closest('.shopify-section') || announcement : announcement;
        annH = el.getBoundingClientRect().height || 0;
      }
      var offset = Math.max(0, annH - y);
      document.body.style.setProperty('--hoq-ann-offset', offset + 'px');
      document.body.classList.toggle('hoq-scrolled', y > 40);

      // hide on scroll down, show on scroll up (once past the hero top area)
      var hasOpenMenu = wrapper.querySelector('details[open]');
      if (!hasOpenMenu && y > 400 && y > lastY + 6) {
        section.classList.add('hoq-header-hidden');
      } else if (y < lastY - 6 || y <= 400) {
        section.classList.remove('hoq-header-hidden');
      }
      lastY = y;
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* ---------- Collection: column switcher (View 1 2 3 4 5) ---------- */
  function initViewSwitcher() {
    var switcher = document.querySelector('[data-hoq-viewswitch]');
    if (!switcher) return;
    var targetId = switcher.getAttribute('data-target') || 'product-grid';
    var buttons = switcher.querySelectorAll('.hoq-viewswitch__btn');
    var key = 'hoq:cols';
    var stored = null;
    try { stored = window.localStorage.getItem(key); } catch (e) {}

    function apply(cols, persist) {
      var grid = document.getElementById(targetId);
      if (!grid) return;
      grid.className = grid.className.replace(/\bhoq-cols-\d\b/g, '').trim();
      grid.classList.add('hoq-cols-' + cols);
      buttons.forEach(function (b) { b.classList.toggle('is-active', b.getAttribute('data-cols') === String(cols)); });
      if (persist) { try { window.localStorage.setItem(key, String(cols)); } catch (e) {} }
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () { apply(b.getAttribute('data-cols'), true); });
    });

    if (stored) apply(stored, false);

    // re-apply after Dawn's facet/filter AJAX re-renders the grid
    var observer = new MutationObserver(function () {
      var grid = document.getElementById(targetId);
      if (grid && !/\bhoq-cols-\d\b/.test(grid.className)) {
        var active = switcher.querySelector('.hoq-viewswitch__btn.is-active');
        if (active) apply(active.getAttribute('data-cols'), false);
      }
    });
    var container = document.getElementById('ProductGridContainer');
    if (container) observer.observe(container, { childList: true, subtree: true });
  }

  /* ---------- Hero scroll hint ---------- */
  function initScrollHint() {
    document.querySelectorAll('[data-hoq-scroll-hint]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var hero = btn.closest('.hoq-hero');
        var next = hero ? hero.getBoundingClientRect().bottom + window.scrollY : window.innerHeight;
        window.scrollTo({ top: next, behavior: 'smooth' });
      });
    });
  }

  /* ---------- Make sure hero videos play (iOS low-power fallback) ---------- */
  function initHeroVideos() {
    document.querySelectorAll('.hoq-hero video, .hoq-tile video').forEach(function (v) {
      v.muted = true;
      v.setAttribute('playsinline', '');
      var p = v.play();
      if (p && p.catch) {
        p.catch(function () {
          var resume = function () { v.play().catch(function () {}); document.removeEventListener('touchstart', resume); };
          document.addEventListener('touchstart', resume, { passive: true });
        });
      }
    });
  }

  /* ---------- Rolling text on hover (KW style) ---------- */
  function initRollingText() {
    var selectors = [
      '.header__inline-menu .header__menu-item > span',
      '.hoq-catrow__title',
      '.hoq-footer__link',
      '.hoq-mega__link',
      '.hoq-mega__all',
      '.hoq-photomenu__all',
      '.hoq-colhero__all',
      '.hoq-hero__link',
      '.hoq-tile__link',
      '.title-wrapper-with-link .link-with-icon',
      '.hoq-drawer-shop__label'
    ];
    document.querySelectorAll(selectors.join(',')).forEach(function (el) {
      if (el.dataset.hoqRoll || el.querySelector('*') || !el.textContent.trim()) return;
      var text = el.textContent.trim();
      el.dataset.hoqRoll = '1';
      el.classList.add('hoq-rollwrap');
      el.innerHTML = '<span class="hoq-roll"><span class="hoq-roll__inner"><span class="hoq-roll__a">' + text.replace(/</g, '&lt;') + '</span><span class="hoq-roll__b" aria-hidden="true">' + text.replace(/</g, '&lt;') + '</span></span></span>';
      var trigger = el.closest('a, summary, button') || el;
      trigger.classList.add('hoq-roll-trigger');
    });
  }

  function init() {
    initRollingText();
    initTransparentHeader();
    initViewSwitcher();
    initScrollHint();
    initHeroVideos();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor: re-init when sections are reloaded
  document.addEventListener('shopify:section:load', function () { init(); });
})();
